import { getProfile } from "@okta/okta-auth-js";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const PageTitle = ({ pageTitle, profile }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        if (profile && profile.allowedModules) {
          const hasDashboard = profile.allowedModules.some(
            (module) =>
              module.value.trim() === "dashboard" &&
              module.operations.includes("menu")
          );
          if (hasDashboard === false) {
            setHasDashboardMenu(false);
          }
        }
      } catch (error) {
        console.error("Failed to fetch profile:", error);
      }
    };

    fetchProfile();
  }, []);
  // Generate breadcrumb items based on the current URL path
  const breadcrumbs = pathnames.map((name, index) => {
    const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
    return {
      path: routeTo,
      label: name,
    };
  });

  return (
    <div
      className="row page-titles mx-0 position-relative align-items-center"
      style={{ position: "relative" }}
    >
      {/* Breadcrumb section aligned to the left */}
      <div className="col-12 d-flex justify-content-start">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            {hasDashboardMenu ? (
              <Link to="/dashboard">dashboard</Link>
            ) : (
              <Link to="/forms">forms</Link>
            )}
          </li>
          {breadcrumbs.map((item, index) =>
            item.label.toLowerCase() !== "dashboard" ? (
              <li
                className={`breadcrumb-item ${
                  index === breadcrumbs.length - 1 ? "active" : ""
                }`}
                key={index}
              >
                <Link to={item.path}>{item.label}</Link>
              </li>
            ) : null
          )}
        </ol>
      </div>

      {/* Centered page title */}
      <h4
        className="page-title text-center position-absolute"
        style={{
          position: "absolute",
          left: "50%",
          transform: "translate(-50%, -50%)",
          top: "50%",
          margin: "0",
          pointerEvents: "none", // 👈 this allows clicks to pass through
        }}
      >
        {pageTitle || "Dashboard"}
      </h4>
    </div>
  );
};

export default PageTitle;
